import { parseAsBoolean, useQueryStates } from 'nuqs'

export function useAddReferralsModal() {
  const [queryStates, setQueryStates] = useQueryStates({
    isShowingAddReferralsModal: parseAsBoolean.withDefault(false),
  })

  return {
    isShowing: queryStates.isShowingAddReferralsModal,
    showModal: () => {
      setQueryStates((prev) => ({
        ...prev,
        isShowingAddReferralsModal: true,
      }))
    },
    hideModal: () => {
      setQueryStates((prev) => ({
        ...prev,
        isShowingAddReferralsModal: false,
      }))
    },
  }
}
